import React from "react";
import "../assets/Timeline.css";

// Your real icons
import img1 from "../assets/icons/walk.svg";
import img2 from "../assets/icons/tray.svg";
import img3 from "../assets/icons/ring.svg";
import img4 from "../assets/icons/Umbrella.svg";
import img5 from "../assets/icons/Scissors.svg";
import img6 from "../assets/icons/Sword.svg";
import img7 from "../assets/icons/plate.png";

const events = [
  { time: "ម៉ោង ០៦:៣០ នាទីព្រឹក", text: "ជួបជុំភ្ញៀវកិត្តិយសដើម្បីរៀបចំពិធីហែជំនូន", icon: img1 },
  { time: "ម៉ោង ០៧:០០ នាទីព្រឹក", text: "ពិធីហែជំនូន (កំណត់)", icon: img2 },
  { time: "ម៉ោង ០៨:០០ នាទីព្រឹក", text: "ពិធីបំពាក់ចិញ្ចៀន", icon: img3 },
  { time: "ម៉ោង ០៨:៣០ នាទីព្រឹក", text: "ពិធីសូត្រមន្តចម្រើនព្រះបរិត្ត", icon: img4 },
  { time: "ម៉ោង ៩០:០០ នាទីព្រឹក", text: "ពិធីកាត់សក់បង្កក់សិរី", icon: img5 },
  { time: "ម៉ោង ១០:៣០ នាទីព្រឹក", text: "ពិធីបង្វិលពពិល ពិធីក្រាបសំពះផ្ទឹមនិងគួចចងដៃ ពីធីបាចផ្កាស្លា", icon: img6 },
  { time: "ម៉ោង ១១:៤៥ នាទីព្រឹក", text: "អញ្ជើញភ្ញៀវកិត្តយសពិសាភោជនាអាហារថ្ងៃត្រង់", icon: img7 },
];

export default function Timeline() {
  return (
    <div className="timeline-wrapper">
      <div className="timeline-container">
        {/* Straight vertical line */}
        <div className="timeline-line" />

        {events.map((ev, i) => (
          <div className="timeline-item" key={i}>
            {/* Left icon */}
            <div className="timeline-icon">
              <img src={ev.icon} alt={`icon-${i}`} />
            </div>

            {/* Center dot with cross arms */}
            <div className="timeline-center">
              <div className="dot" />
            </div>

            {/* Right text */}
            <div className="timeline-content">
              <h3 className="time">{ev.time}</h3>
              <p className="desc me-5">{ev.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
